import { useRouter } from 'next/router';
import React, { useState } from 'react';

import { cx } from '@emotion/css';
import { Category } from '@lib/wordpress.d';
import { HOME_ROUTES } from '@util/constants';

type Props = {
  styles: any;
  categories: Category[];
  selectedCategory?: string;
};
export const Tabs = (props: Props) => {
  const { styles, categories } = props;
  const router = useRouter();
  const [selectedCategory, setSelectedCategory] = useState(
    props.selectedCategory ?? 'all',
  );

  const onCategoryClick = (categoryId: any) => {
    setSelectedCategory(categoryId);
    router.replace({
      pathname: HOME_ROUTES.BLOG,
      query: { category: categoryId },
    });
  };

  return (
    <div className={styles.tabs}>
      <button
        className={cx(
          styles.tab_button,
          selectedCategory == 'all' && styles.tab_button_active,
        )}
        data-tab="all"
        onClick={() => onCategoryClick('all')}>
        View all
      </button>
      {categories?.map((category, index) => (
        <button
          key={index}
          className={cx(
            styles.tab_button,
            selectedCategory == category.id.toString() &&
              styles.tab_button_active,
          )}
          data-tab={category.slug}
          onClick={() => onCategoryClick(category?.id)}>
          <span dangerouslySetInnerHTML={{ __html: category?.name ?? '' }} />
        </button>
      ))}
    </div>
  );
};
